<template>
    <section role="button" @click="openSearchTrigger" aria-label="Hva kan vi hjelpe deg med?" class="container container--medium container--calcPadding margin-both-xl">
        <div class="inner padding padding-bottom-lg padding-top-lg">
            <h2 class="medium-text titler text-center">Hva kan vi hjelpe deg med?</h2>
            <div class="search-button module-text">
                <span>Søk her</span>
                <span v-html="searchIcon"></span>
            </div>
        </div>
    </section>
</template>

<script>
import { search } from '@/icons'
import { mapMutations } from 'vuex';

export default {
    name: 'search-button-module',
    data(){
        return{
            searchIcon : search('#2D373F')
        }
    },
    computed:{
        
    },
    components:{
    },
    methods:{
        openSearchTrigger(){
            this.SEARCH_MODAL_CHANGE_STATE()
        },
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
        ]),
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-search_button{
    .inner{
        background-color: $darkLight;
        color: #fff;
        transition: color 0.2s ease-in-out, background 0.2s ease-in-out;
        will-change: color, background;
        cursor: pointer;
        &:hover{
            //background: $yellow;
            //color: $dark;
            /* .search-button{
                background: $darkLight;
                color: #fff;
                svg{
                    .magnifying-glass{
                        fill: #fff;
                    }
                }
            } */
        }
    }
    
    .titler{
        margin-bottom: 25px;
        @include mquery($phone){
            margin-bottom: 15px;
        }
    }
    .search-button{
        background: #fff;
        max-width: 700px;
        color: $dark;
        margin: 0 auto;
        border-radius: $radius;
        line-height: 1;
        padding: 10px 25px;
        display: flex;
        justify-content: space-between;
        transition: color 0.2s ease-in-out, background 0.2s ease-in-out;
        will-change: color, background;
        @include mquery($phone){
            padding: 8px 20px;
            max-width: 70%;
        }

        svg{
            .magnifying-glass{
                transition: fill 0.2s ease-in-out;
                will-change: fill;
            }
            @include mquery($phone){
                width: 15px;
                height: 15px;
            }

        }
    }
}

</style>